import { render } from "./FooterRodekruisvlaanderen.vue?vue&type=template&id=d7d95900&scoped=true"
import script from "./FooterRodekruisvlaanderen.vue?vue&type=script&lang=js"
export * from "./FooterRodekruisvlaanderen.vue?vue&type=script&lang=js"

import "./FooterRodekruisvlaanderen.vue?vue&type=style&index=0&id=d7d95900&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d95900"]])

export default __exports__